<script>
  import { notification } from "../store";
</script>

<style>
  .preview-body {
    max-width: 400px;
    margin: 0 15px 15px 0;
    box-sizing: content-box;
    padding: 10px 0 0 0;
  }
  .preview-body-inner {
    max-width: 400px;
    margin: 0 15px 15px 15px;
    box-sizing: content-box;
    position: relative;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    border-radius: 0;
    box-shadow: none;
    background-color: #202020;
    z-index: 2;
  }

  .preview-body-content {
    display: flex;
    flex-direction: row;
  }

  .preview-body-icon {
    display: block;
    background-size: contain;
    background-repeat: no-repeat;
    margin: 20px;
    width: 20px;
    height: 20px;
  }
  .preview-body-icon.icon {
    display: block;
    background-size: contain;
    background-repeat: no-repeat;
    width: 50px;
    height: 50px;
    margin: 10px;
  }
  .preview-body-innerContents {
    flex-grow: 1;
    padding: 10px 20px 10px 10px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    width: 80%;
  }
  .preview-img {
    display: block;
    background-size: cover;
    width: 100%;
    min-height: 150px;
    background: no-repeat 50%;
    padding: 0;
  }
  .preview-title {
    color: #fff;
    font-size: 1rem;
    line-height: 1.5;
    text-align: left;
    overflow: unset;
    max-height: unset;
  }
  .preview-desc {
    color: #bbb;
    font-size: 1rem;
    text-align: left;
    line-height: 1.5;
    overflow: unset;
    max-height: unset;
  }
  .preview-browserSub {
    color: #bbb;
    font-size: 0.8rem;
    text-align: left;
    padding: 6px 0;
  }

  .preview-buttons {
    display: flex;
    flex-direction: row;
    min-height: 50px;
    width: 100% !important;
    justify-content: center;
    padding: 0 !important;
    margin: 0;
    text-align: center !important;
  }

  .preview-buttons.multiple {
    justify-content: center;
  }

  .preview-buttons .previewBtn {
    width: 94%;
    height: 45px;
    background-color: #434343;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1rem;
    margin: 10px 5px;
  }

  .preview-buttons.multiple .previewBtn {
    width: 46%;
  }

  footer {
    height: 40px;
    padding-right: 20px;
    background-color: #000;
    position: relative;
    display: flex;
    align-items: center;
    direction: rtl;
  }
  footer svg {
    width: 300px;
    height: 32px;
  }
  footer time {
    position: absolute;
    text-align: center;
    color: #fff;
    font-size: 13px;
    line-height: 1.2;
    right: 65px;
    direction: ltr;
  }
</style>

<div class="preview-wrapper">
  <div
    class="preview-body"
    style="background-image:
    url('/wp-content/plugins/best-push/assets/web-bg.jpg');">

    <div class="preview-body-inner">

      {#if $notification.imageUrl}
        <div
          class="preview-img"
          style="background-image: url({$notification.imageUrl});" />
      {/if}

      <div class="preview-body-content">
        <div
          class="preview-body-icon"
          class:icon={$notification.iconUrl}
          style="background-image: url({$notification.iconUrl || '/wp-content/plugins/best-push/assets/chrome.png'});" />
        <div class="preview-body-innerContents">
          <div class="preview-title">{$notification.title || 'Title'}</div>
          <div class="preview-desc">{$notification.content || 'Content'}</div>
          <div class="preview-browserSub">Google Chrome • example.com</div>
        </div>
      </div>

      {#if ($notification.buttons || []).length > 0}
        <div
          class="preview-buttons"
          class:multiple={($notification.buttons || []).length > 1}>
          {#each $notification.buttons as button, idx}
            <div class="previewBtn">{button.text || 'Button ' + (idx + 1)}</div>
          {/each}
        </div>
      {/if}
    </div>

    <footer>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 267.333 28.567">
        <path
          fill="#FFF"
          d="M257.333 4v13h-5l-3 3-3-3h-5V4h16zm-13 3v1h10V7h-10zm0
          3v1h10v-1h-10zm0 3v1h6v-1h-6z" />
        <circle fill="#1E1F1E" cx="258.833" cy="19.5" r="8" opacity=".8" />
        <path
          fill="#1E1F1E"
          d="M258.833 28c-4.687 0-8.5-3.813-8.5-8.5 0-4.687 3.813-8.5 8.5-8.5
          4.687 0 8.5 3.813 8.5 8.5 0 4.687-3.813 8.5-8.5 8.5zm0-16c-4.136 0-7.5
          3.364-7.5 7.5s3.364 7.5 7.5 7.5 7.5-3.364 7.5-7.5-3.364-7.5-7.5-7.5z" />
        <path
          fill="#FFF"
          d="M260.779 21.067c0 .41-.07.781-.211
          1.113s-.341.617-.601.855-.573.422-.94.551-.775.193-1.225.193c-.781
          0-1.361-.117-1.74-.352v-1.02c.57.367 1.154.551 1.752.551.305 0
          .579-.045.823-.135s.452-.215.624-.375.304-.354.396-.58.138-.475.138-.744c0-.547-.184-.976-.551-1.286s-.9-.466-1.6-.466c-.113
          0-.232.002-.357.006l-.375.015s-.247.013-.366.021c-.125.006-.228.018-.325.029l.287-4.213h3.885v.867h-3.053l-.17
          2.467c.125-.008.258-.015.398-.021s.266-.009.375-.009c.445 0 .844.059
          1.195.176s.649.284.894.501.43.482.557.797.19.669.19 1.059zM156.233
          13.6v.4l2 1.3-1.2 3-2.3-.5-.4.4.5 2.3-3 1.2-1.3-2h-.4l-1.3
          2-3-1.2.5-2.3-.4-.4-2.3.5-1.2-3 2-1.3v-.4l-2-1.3 1.2-3
          2.3.5.4-.4-.5-2.3 3-1.2 1.3 2h.4l1.3-2 3 1.2-.5 2.3.4.4 2.3-.5 1.2 3-2
          1.3zm-.9
          1V13l1.8-1.1-.7-1.6-2.1.5c-.2-.2-.3-.4-.5-.5-.2-.2-.4-.3-.6-.5l.5-2.1-1.6-.7-1.2
          1.8h-1.6l-1.1-1.8-1.6.7.5
          2.1c-.2.2-.4.3-.5.5-.2.2-.3.4-.5.6l-2.1-.5-.7 1.6 1.8 1.2v1.6l-1.8
          1.1.7 1.6 2.1-.5c.2.2.3.4.5.5.2.2.4.3.6.5l-.5 2.1 1.6.7
          1.2-1.8h1.6l1.1 1.8
          1.6-.7-.5-2.1c.2-.2.4-.3.5-.5.2-.2.3-.4.5-.6l2.1.5.7-1.6-1.8-1.2zm-5-3.6c.375.009.746.076
          1.1.2.329.152.633.354.9.6.256.259.46.564.6.9.162.343.231.722.2
          1.1a3.586 3.586 0 0 1-.2 1.1 3.485 3.485 0 0
          1-.6.9c-.259.256-.564.46-.9.6a2.161 2.161 0 0 1-1.1.2 3.586 3.586 0 0
          1-1.1-.2 3.485 3.485 0 0 1-.9-.6 2.827 2.827 0 0 1-.6-.9 2.161 2.161 0
          0
          1-.2-1.1c.009-.375.076-.746.2-1.1.152-.329.354-.633.6-.9.259-.256.564-.46.9-.6.34-.171.722-.24
          1.1-.2zm0
          5c.278-.007.551-.075.8-.2.2-.1.5-.3.7-.4s.3-.4.4-.7c.267-.5.267-1.1
          0-1.6-.1-.2-.3-.5-.4-.7s-.4-.3-.7-.4a2.36 2.36 0 0 0-.8-.2 1.888 1.888
          0 0 0-.8.2c-.2.1-.5.3-.7.4s-.3.4-.4.7c-.267.5-.267 1.1 0
          1.6.1.2.3.5.4.7s.4.3.7.4c.253.113.524.181.8.2z" />
        <g fill="#FFF">
          <path
            opacity=".4"
            d="M128.233 21.8l-.7-.7a10.394 10.394 0 0 0 0-14.3l.7-.7a11.555
            11.555 0 0 1 0 15.7" />
          <path
            d="M126.033 19.8l-.7-.7a7.31 7.31 0 0 0 0-10.1l.7-.7a8.27 8.27 0 0 1
            0 11.5" />
          <path
            d="M123.833 17.7l-.7-.7a4.35 4.35 0 0 0 0-6l.7-.7c2 2.061 2 5.339 0
            7.4M120.333 9.4v9.2l-2.3-2.3-.3-.3h-1.4v-4h1.4l.3-.3
            2.3-2.3zm1-1.4h-1l-3 3h-2v6h2l3 3h1V8z" />
        </g>
        <g fill="#FFF">
          <path
            d="M97.333 19h-1a4.95 4.95 0 0 1 4.901-5h.099v1a4.013 4.013 0 0 0-4
            4z" />
          <path
            d="M94.333 19h-1a8.024 8.024 0 0 1 8-8v1a6.957 6.957 0 0 0-7
            6.914V19z" />
          <path
            d="M91.333 19h-1c-.018-6.057 4.878-10.982
            10.936-11h.064v1c-5.516.016-9.984 4.484-10 10zM101.333 18a1 1 0 1
            1-1-1 .945.945 0 0 1 1 1" />
        </g>
        <g fill="#FFF">
          <path d="M79.333 18h-15v-8h15v8zm-14-1h13v-6h-13v6z" />
          <path d="M80.333 15h-2v-2h2v2z" />
        </g>
        <path
          fill="#FFF"
          d="M51.833 17.3l-5.5-5.5-5.5 5.5-.5-.6 6-6 6 6-.5.6z" />
        <path opacity=".2" fill="#FFF" d="M27.833 4h1v20h-1z" />
        <path
          fill="#FFF"
          d="M14.133 11.3l.9.6c.284.218.522.489.7.8.193.306.328.645.4 1
          .115.356.182.726.2 1.1h-1a5.028 5.028 0 0 0-.2-1.2 8.88 8.88 0 0
          0-.6-1 2.075 2.075 0 0 0-1-.6 2.534 2.534 0 0
          0-1.2-.2c-.407.018-.81.085-1.2.2a8.88 8.88 0 0 0-1
          .6c-.292.269-.5.616-.6 1-.163.378-.232.79-.2 1.2a3.517 3.517 0 0 1-.3
          1.4c-.212.431-.52.807-.9
          1.1l.9.6c.284.218.522.489.7.8.193.306.328.645.4 1 .115.356.182.726.2
          1.1h-1a5.028 5.028 0 0 0-.2-1.2 8.88 8.88 0 0 0-.6-1 2.075 2.075 0 0
          0-1-.6 2.534 2.534 0 0 0-1.2-.2c-.407.018-.81.085-1.2.2a8.88 8.88 0 0
          0-1 .6c-.292.269-.5.616-.6 1-.163.378-.232.79-.2
          1.2h-1c.018-.374.085-.744.2-1.1.116-.34.25-.674.4-1a2.71 2.71 0 0 1
          .7-.8c.276-.234.578-.435.9-.6a2.44 2.44 0 0 1-.9-1.1 3.208 3.208 0 0
          1-.3-1.4c.018-.407.085-.81.2-1.2a8.88 8.88 0 0 1 .6-1c.269-.291.616-.5
          1-.6.378-.163.79-.232 1.2-.2.482.003.959.105 1.4.3.431.212.807.519
          1.1.9.21-.375.48-.713.8-1a7.001 7.001 0 0 1 1-.8 2.44 2.44 0 0
          1-.9-1.1 3.208 3.208 0 0 1-.3-1.4c.018-.407.085-.81.2-1.2a8.88 8.88 0
          0 1 .6-1c.269-.291.616-.5 1-.6.378-.163.79-.232 1.2-.2.407.018.81.085
          1.2.2.346.178.68.378 1 .6.292.269.5.616.6 1 .163.378.232.79.2
          1.2a3.517 3.517 0 0 1-.3 1.4c-.223.48-.568.893-1 1.2zm-7.8 5.6a2.36
          2.36 0 0 0
          .8-.2c.2-.1.5-.2.6-.4s.3-.4.4-.6c.125-.249.193-.522.2-.8a2.36 2.36 0 0
          0-.2-.8c-.1-.2-.2-.5-.4-.6s-.4-.3-.6-.4a1.888 1.888 0 0 0-.8-.2 2.36
          2.36 0 0 0-.8.2.917.917 0 0 0-.6.4c-.1.2-.3.4-.4.6a1.888 1.888 0 0
          0-.2.8c.019.276.087.547.2.8.1.2.2.5.4.6s.4.3.6.4c.249.125.522.193.8.2zm4-8c.019.276.087.547.2.8.1.2.2.5.4.6s.4.3.6.4c.249.125.522.193.8.2a2.36
          2.36 0 0 0
          .8-.2c.2-.1.5-.2.6-.4s.3-.4.4-.6c.125-.249.193-.522.2-.8a2.36 2.36 0 0
          0-.2-.8c-.1-.2-.2-.5-.4-.6s-.4-.3-.6-.4a1.888 1.888 0 0 0-.8-.2 2.36
          2.36 0 0 0-.8.2.917.917 0 0 0-.6.4c-.1.2-.3.4-.4.6a2.36 2.36 0 0
          0-.2.8z" />
      </svg>
      <time>
        <p>6:30 AM</p>
        <p>7/30/2015</p>
      </time>
    </footer>
  </div>
</div>
